import { computed, ref } from 'vue'

export const newExports = ref([])
export const hasNewExports = computed(() => {
  return newExports.value.length
})
